import styled from "styled-components";

import { Checkbox } from "../Checkbox";
import { Input } from "../Input/Input";
import { RadioButton } from "../RadioButton";

export const StyledSelectInput = styled(Input)``;

StyledSelectInput.displayName = "StyledSelectInput";

export const StyledSelectForm = styled.form`
  margin: 12px 12px 0 12px;
  display: flex;

  ${StyledSelectInput} {
    width: 100%;
    border-radius: 4px;
  }

  * {
    margin: auto 0;
  }
`;

StyledSelectForm.displayName = "StyledSelectForm";

export const StyledStartAdornment = styled.div`
  margin-right: 8px;
  margin-left: -4px;
`;

StyledStartAdornment.displayName = "StyledStartAdornment";

export const StyledEndAdornment = styled.div`
  margin-left: 8px;
  margin-right: -4px;
`;

StyledEndAdornment.displayName = "StyledEndAdornment";

export const StyledCheckbox = styled(Checkbox)`
  margin-left: 12px;
`;

StyledCheckbox.displayName = "StyledCheckbox";

export const StyledRadioButton = styled(RadioButton)`
  margin-left: 12px;
`;

StyledRadioButton.displayName = "StyledRadioButton";
